var map = {
	"./en": "84ff",
	"./en.ts": "84ff",
	"./helpers": "e0bf",
	"./helpers.ts": "e0bf",
	"./nl": "2e91",
	"./nl.ts": "2e91",
	"./tree": "2e8d",
	"./tree.ts": "2e8d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e6ea";